import { useContext } from 'react';

import { ModalContext } from '@shared/ui/components/Modal/ModalContext';

import { Button } from '../Button';

type DialogContentActionsProps = {
  confirmLabel?: string;
  onConfirm: () => Promise<void> | void;
};

export function ModalContentActions({ confirmLabel = 'Confirm', onConfirm }: DialogContentActionsProps) {
  const { setOpen } = useContext(ModalContext);

  async function handleConfirm() {
    await onConfirm();

    setOpen(false);
  }

  return (
    <div className="flex items-center gap-2 justify-end mt-8">
      <Button type="button" onClick={handleConfirm}>
        {confirmLabel}
      </Button>
      <Button type="button" variant="link" onClick={() => setOpen(false)}>
        Cancel
      </Button>
    </div>
  );
}
